import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { LogEntry } from './LogEntry.js';
import { LogLevel } from './LogLevel.js';
import MediaQuery from 'react-responsive';
import { convertDateFormat } from '../DateFormatConverter.js';
import { Settings } from './Settings';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { copyTextToClipboard } from '../Providers/ClipboardProvider';
import { ExceptionParser } from '../ExceptionParser';
var exceptionParser = new ExceptionParser();
import style from './LogTable.css';
export var LogTable = /*#__PURE__*/function (_Component) {
  _inherits(LogTable, _Component);

  var _super = _createSuper(LogTable);

  function LogTable() {
    var _this;

    _classCallCheck(this, LogTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showLevelSettings: false,
      highlightedRequest: null,
      copyActive: null
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLevelSettings", function () {
      _this.setState({
        showLevelSettings: !_this.state.showLevelSettings
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleRelativeTime", function () {
      _this.props.setRelative(!_this.props.relative);
    });

    return _this;
  }

  _createClass(LogTable, [{
    key: "highlightRequest",
    value: function highlightRequest(highlightedRequest) {
      this.setState({
        highlightedRequest: highlightedRequest
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(entry, relative) {
      var time = new Date(entry.time);

      if (relative) {
        return OC.Util.relativeModifiedDate(time);
      } else {
        return OC.Util.formatDate(time, convertDateFormat(this.props.dateFormat));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var timeClass = style.time + (this.props.relative ? ' ' + style.relative : '');
      var rows = this.props.entries.map(function (entry, i) {
        var className = style['level_' + entry.level];

        if (entry.reqId === _this2.state.highlightedRequest) {
          className += ' ' + style.highlight;
        }

        var copyEntry = function copyEntry(raw) {
          var text = raw ? JSON.stringify(entry) : "\n[".concat(entry.app, "] ").concat(LogLevel.levels[entry.level], ": ").concat(exceptionParser.format(entry.message), "\n\n") + (entry.method ? "".concat(entry.method, " ").concat(entry.url, "\n") : '') + (entry.remoteAddr ? "from ".concat(entry.remoteAddr, " ") : '') + (entry.user !== '--' ? "by ".concat(entry.user, " ") : '') + "at ".concat(entry.time, "\n");
          copyTextToClipboard(text.trim());

          _this2.setState({
            copyActive: null
          });
        };

        return /*#__PURE__*/React.createElement("tr", {
          className: className + (_this2.state.copyActive === entry.id ? ' ' + style.active : ''),
          key: entry.id,
          onClick: _this2.highlightRequest.bind(_this2, entry.reqId)
        }, /*#__PURE__*/React.createElement("td", {
          className: style.level
        }, /*#__PURE__*/React.createElement(LogLevel, {
          level: entry.level
        })), /*#__PURE__*/React.createElement("td", {
          className: style.app
        }, entry.app), /*#__PURE__*/React.createElement("td", {
          className: style.message
        }, /*#__PURE__*/React.createElement(LogEntry, {
          message: entry.message,
          exception: entry.exception
        })), /*#__PURE__*/React.createElement("td", {
          className: style.copy
        }, /*#__PURE__*/React.createElement("button", {
          title: t('logreader', 'Copy'),
          className: "icon icon-clippy",
          onClick: function onClick() {
            _this2.setState({
              copyActive: _this2.state.copyActive === entry.id ? null : entry.id
            });
          }
        }), _this2.state.copyActive === entry.id ? /*#__PURE__*/React.createElement("div", {
          className: style.copyMenu + ' popovermenu bubble open menu'
        }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
          className: "menuitem icon icon-clippy",
          onClick: function onClick() {
            return copyEntry(true);
          }
        }, t('logreader', 'Copy raw'))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
          className: "menuitem icon icon-clippy",
          onClick: function onClick() {
            return copyEntry(false);
          }
        }, t('logreader', 'Copy formatted'))))) : []), /*#__PURE__*/React.createElement("td", {
          className: timeClass,
          title: _this2.formatDate(entry, !_this2.props.relative)
        }, _this2.formatDate(entry, _this2.props.relative)));
      });
      var smallRows = this.props.entries.map(function (entry, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: style['level_' + entry.level] + ' ' + style.row,
          key: i
        }, /*#__PURE__*/React.createElement("div", {
          className: style.level + ' ' + style.column
        }, /*#__PURE__*/React.createElement(LogLevel, {
          level: entry.level
        })), /*#__PURE__*/React.createElement("div", {
          className: style.app + ' ' + style.column
        }, entry.app), /*#__PURE__*/React.createElement("div", {
          className: timeClass + ' ' + style.column
        }, _this2.formatDate(entry, _this2.props.relative)), /*#__PURE__*/React.createElement("div", {
          className: style.message + ' ' + style.column
        }, /*#__PURE__*/React.createElement(LogEntry, {
          message: entry.message,
          exception: entry.exception
        })));
      });

      if (rows.length === 0) {
        rows = /*#__PURE__*/React.createElement("tr", {
          className: style.empty
        }, /*#__PURE__*/React.createElement("td", {
          colSpan: "4"
        }, /*#__PURE__*/React.createElement("div", {
          className: "emptycontent"
        }, /*#__PURE__*/React.createElement("div", {
          className: "icon-filetype-text"
        }), /*#__PURE__*/React.createElement("h2", null, t('logreader', 'No server logs')), /*#__PURE__*/React.createElement("p", null, this.props.hidden > 0 ? t('logreader', 'One or more entries are hidden by the log level filter') : t('logreader', 'Everything is working fine')))));
      }

      var levelHeader = /*#__PURE__*/React.createElement(React.Fragment, null, t('logreader', 'Level'), /*#__PURE__*/React.createElement("span", {
        className: style['log-settings-toggle'] + ' icon-more'
      }));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
        minWidth: 750
      }, /*#__PURE__*/React.createElement("table", {
        className: style.logs
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        className: style.level + ' ' + (this.state.showLevelSettings ? style.active : ''),
        onClick: this.toggleLevelSettings
      }, levelHeader, this.state.showLevelSettings ? /*#__PURE__*/React.createElement(Settings, {
        setLevel: this.props.setLevel,
        levels: this.props.levels,
        live: this.props.live,
        setLive: this.props.setLive,
        onLogFile: this.props.onLogFile
      }) : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement("th", {
        className: style.app
      }, t('logreader', 'App')), /*#__PURE__*/React.createElement("th", {
        className: style.message
      }, t('logreader', 'Message')), /*#__PURE__*/React.createElement("th", {
        className: style.copy
      }), /*#__PURE__*/React.createElement("th", {
        className: timeClass,
        onClick: this.toggleRelativeTime
      }, /*#__PURE__*/React.createElement("span", null, t('logreader', 'Time'))))), /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        transitionName: "highlight",
        transitionEnterTimeout: 1500,
        transitionLeaveTimeout: 1500,
        component: "tbody"
      }, rows))), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 768
      }, /*#__PURE__*/React.createElement("div", {
        className: style.smallHeader
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.toggleLevelSettings
      }, levelHeader), this.state.showLevelSettings ? /*#__PURE__*/React.createElement(Settings, {
        setLevel: this.props.setLevel,
        levels: this.props.levels
      }) : /*#__PURE__*/React.createElement("div", {
        className: "hidden"
      })), /*#__PURE__*/React.createElement("div", {
        className: style.logs
      }, smallRows)));
    }
  }]);

  return LogTable;
}(Component);